import React from 'react';
import styles from './index.module.scss';

const LoadingAnimation = ({
  message = "正在分析您的问卷...",
  subMessage = "AI正在为您生成个性化推荐方案",
  type = "questionnaire", // questionnaire, chat, general
  fadeOut = false // 是否开始淡出动画
}) => {
  const getAnimationContent = () => {
    switch (type) {
      case 'questionnaire':
        return (
          <div className={styles.questionnaireLoading}>
            <div className={styles.iconContainer}>
              <div className={styles.mainIcon}>🤖</div>
              <div className={styles.floatingIcons}>
                <span className={styles.floatingIcon} style={{ '--delay': '0s' }}>📋</span>
                <span className={styles.floatingIcon} style={{ '--delay': '0.5s' }}>⚙️</span>
                <span className={styles.floatingIcon} style={{ '--delay': '1s' }}>🔬</span>
                <span className={styles.floatingIcon} style={{ '--delay': '1.5s' }}>💡</span>
              </div>
            </div>
            <div className={styles.progressBar}>
              <div className={styles.progressFill}></div>
            </div>
          </div>
        );
      case 'chat':
        return (
          <div className={styles.chatLoading}>
            <div className={styles.typingDots}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        );
      default:
        return (
          <div className={styles.generalLoading}>
            <div className={styles.spinner}></div>
          </div>
        );
    }
  };

  return (
    <div className={`${styles.loadingContainer} ${styles[type]} ${fadeOut ? styles.fadeOut : ''}`}>
      {getAnimationContent()}
      <div className={styles.messageContainer}>
        <div className={styles.mainMessage}>{message}</div>
        {subMessage && <div className={styles.subMessage}>{subMessage}</div>}
      </div>
    </div>
  );
};

export default LoadingAnimation;
